/* import __COLOCATED_TEMPLATE__ from './sender-summary.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();